import { Button } from '@/components/ui/button'
import { useAxios } from '@/contexts/AxiosProvider'
import { useRouter } from '@/hooks/useRouter'
import { motion } from 'framer-motion'
import { useUser } from '@clerk/clerk-react'

export const DebateCard = ({ debate }) => {
  const router = useRouter()
  const { user } = useUser()

  const handleHallJoin = (e, id) => {
    e.preventDefault()
    router.push(`/hall/${id}`)
  }

  const formatBadgeColors = {
    'Lincoln Douglas': 'bg-green-700',
    'Quick Round': 'bg-blue-700',
    'Team Policy': 'bg-yellow-700',
    'Public Forum': 'bg-pink-700',
    Extemp: 'bg-red-700',
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.3, ease: 'easeOut' }}
      className="relative dark:bg-accent border border-gray-300 dark:border-none  shadow rounded-lg p-4 flex flex-col justify-between"
    >
      <div>
        <div className="flex items-start justify-between">
          <h3 className="text-md md:text-lg lg:text-xl font-bold">{debate.title}</h3>
          <span
            className={`text-xs md:text-sm text-white font-medium px-2 py-1 rounded-full whitespace-nowrap ${
              formatBadgeColors[debate.format] || 'bg-gray-700'
            }`}
          >
            {debate.format}
          </span>
        </div>
        <p className="mt-2 text-sm md:text-base">{debate.topic}</p>
        {debate.subject && (
          <p className="mt-1 text-xs md:text-sm text-gray-500">Subject: {debate.subject}</p>
        )}
      </div>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        {user && (
          <Button
            variant="secondary"
            size="sm"
            onClick={(e) => handleHallJoin(e, debate.hallId)}
            className="px-4 opacity-50 hover:opacity-100 text-black dark:text-white duration-300 ease-in-out font-semibold"
          >
            Join
          </Button>
        )}
      </div>
    </motion.div>
  )
}
